import { render, staticRenderFns } from "./CountdownHelper.vue?vue&type=template&id=2f649fa2&scoped=true&"
import script from "./CountdownHelper.vue?vue&type=script&lang=ts&"
export * from "./CountdownHelper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f649fa2",
  null
  
)

export default component.exports